module.exports = __webpack_public_path__ + "static/media/Page 3.61badab3.mp4";